import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';

import CurrencyConverter from '../../CurrencyConverter';
import WishListIcon from '../../WishListIcon';
import messages from '../../../locale/messages';
import { getFeaturedCarImagePath } from './featuredCarsData';

import s from './FeaturedCars.css';

const FeaturedCarCard = ({ car, intl }) => {
  const imagePath = getFeaturedCarImagePath(car.photo, car.imageSize);
  const carTitle = intl.formatMessage(messages[car.titleMessageKey]);
  const perDay = intl.formatMessage(messages.newLandingPerDay);

  return (
    <div className={s.carCardModern}>
      <div className={s.imgContainer}>
        <a href={car.href} className={s.carCardMediaLink}>
          {imagePath && (
            <img key={imagePath} src={imagePath} alt={carTitle} />
          )}
        </a>
        {car.listId && (
          <div
            className={s.featuredCarWishListWrapper}
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
            role="presentation"
          >
            <WishListIcon
              listId={car.listId}
              isChecked={car.wishListStatus}
              heartIcon={s.featuredCarWishList}
            />
          </div>
        )}
      </div>
      <a href={car.href} className={s.carCardDetailsLink}>
        <div className={cx(s.carDetailsModern, 'textAlignRightRTL')}>
          <h3 className={cx(s.carNameModern, 'textAlignRightRTL')}>
            <FormattedMessage {...messages[car.titleMessageKey]} />
          </h3>
          <p className={cx(s.carMeta, 'textAlignRightRTL')}>
            {car.year ? `${car.year} · ` : ''}
            <span className="directionLtr">{car.rating}</span>
            <span className={s.starIcon}>★</span>
            {' '}
            <span className={s.reviewCount}>({car.reviews})</span>
          </p>
          <p className={cx(s.carPriceModern, 'textAlignRightRTL')}>
            <FormattedMessage
              {...messages.newLandingFeaturedCarPrice}
              values={{
                dailyPrice: (
                  <strong className="directionLtr">
                    <CurrencyConverter amount={car.basePrice} from={car.currency} />
                  </strong>
                ),
                perDay: <span className="PerDayRTL">{perDay}</span>,
              }}
            />
          </p>
        </div>
      </a>
    </div>
  );
};

FeaturedCarCard.propTypes = {
  car: PropTypes.shape({
    id: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    listId: PropTypes.number,
    wishListStatus: PropTypes.bool,
    photo: PropTypes.string,
    imageSize: PropTypes.string,
    titleMessageKey: PropTypes.string.isRequired,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rating: PropTypes.string,
    reviews: PropTypes.string,
    basePrice: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  intl: PropTypes.object.isRequired,
};

export const FeaturedCarCardPlaceholder = () => (
  <div className={cx(s.carCardModern, s.carCardPlaceholder)} aria-hidden="true">
    <div className={s.imgContainer} />
    <div className={s.carDetailsModern}>
      <h3 className={s.carNameModern}>&nbsp;</h3>
      <p className={s.carMeta}>&nbsp;</p>
      <p className={s.carPriceModern}>&nbsp;</p>
    </div>
  </div>
);

export default injectIntl(withStyles(s)(FeaturedCarCard));
